import axios from "axios";

// Resolve backend base URL with smart fallbacks so a stale build never traps
// the user on a wrong host:
//   1. Same-origin if running on the production domain (joincastline.com or any
//      subdomain) — guarantees same-origin cookies + zero CORS friction.
//   2. The build-time REACT_APP_BACKEND_URL env var (used in dev / preview).
//   3. window.location.origin as a last resort.
function resolveBackend() {
    if (typeof window !== "undefined") {
        const host = window.location.hostname || "";
        if (host === "joincastline.com" || host.endsWith(".joincastline.com")) {
            return window.location.origin;
        }
    }
    const envUrl = process.env.REACT_APP_BACKEND_URL;
    if (envUrl) return envUrl;
    if (typeof window !== "undefined") return window.location.origin;
    return "";
}

const BACKEND_URL = resolveBackend();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
